// PC 시각/시간대와 무관한 안내용 시계다. 실제 인증·적립은 항상 서버가 다시 판정한다.
export function createLearningDeadline(now = () => performance.now()) {
  let anchor = null
  return {
    clear() { anchor = null },
    sync(timing) {
      const server = Date.parse(timing?.serverNow), boundary = Date.parse(timing?.boundaryAt)
      anchor = Number.isFinite(server) && Number.isFinite(boundary) && ['REAUTH_REQUIRED', 'LEARNING_PERIOD_ENDED'].includes(timing?.reason)
        ? { remaining: boundary - server, sampled: now(), reason: timing.reason } : null
    },
    read() {
      if (!anchor) return null
      const remaining = Math.max(0, anchor.remaining - Math.max(0, now() - anchor.sampled))
      return { reason: anchor.reason, seconds: Math.ceil(remaining / 1000), warning: remaining <= 15 * 60 * 1000, expired: remaining === 0 }
    },
  }
}
